import rison from 'rison';

import {api} from './Api';
import {Integration, ApiParams, ISort, INTEGRATION_LOADING_SOURCE} from '../models';
import {fromDataToIntegration, fromIntegrationToData} from '../utils/integration';
import {getRequestParams} from "../utils/api";

const resIntegrationToData = (res: any) => ({
  ...res.data,
  result: fromIntegrationToData(res.data.result)
});

export const getIntegration = (uid: string) => {
  return api.get(`integration/${uid}`).then(resIntegrationToData);
}

export const getIntegrations = (
  params: ApiParams | undefined,
  sort: ISort | undefined,
  source?: INTEGRATION_LOADING_SOURCE
) => {
  const requestParams: any = getRequestParams(params, sort);

  if (
    [INTEGRATION_LOADING_SOURCE.REPORT, INTEGRATION_LOADING_SOURCE.LOGS].includes(source as any)
  ) {
    requestParams.columns = [
      'uid', 'name', 'type', 'config',
    ]; // exclude `sharing settings` and `reports`
  }

  return api.get(`integration/?q=${rison.encode(requestParams)}&source=${source || ''}`).then((res: any) => {
    return {
      ...res.data,
      result: res.data.result.map(fromIntegrationToData)
    };
  });
}

export const createIntegration = (integration: Partial<Integration>) => {
  return api.post(`integration/`,
    fromDataToIntegration(integration)
  ).then(resIntegrationToData);
}

export const updateIntegration = (uid: string, integration: Partial<Integration>) => {
  return api.put(`integration/${uid}`,
    fromDataToIntegration(integration, true)
  ).then(resIntegrationToData);
}

export const deleteIntegration = (uid: string) => {
  return api.delete(`integration/${uid}`).then((res: any) => res.data);
}

export const testIntegration = (integration: Partial<Integration>) => {
  return api.post(`integration/test`, integration).then((res: any) => res.data);
}

export const getIntegrationSharingSettings = (uid: string) => {
  return api.get(`/integration/${uid}/sharing_settings`).then((res: any) => res.data);
};

export const shareIntegrationWithUser = (uid: string, userUid: string, permission: string) => {
  const payload = {
    user_uid: userUid,
    permission
  };

  return api.post(`/integration/${uid}/share_with_user`, payload).then((res: any) => res.data);
};

export const shareIntegrationWithGroup = (uid: string, groupUid: string, permission: string) => {
  const payload = {
    group_uid: groupUid,
    permission
  };

  return api.post(`/integration/${uid}/share_with_group`, payload).then((res: any) => res.data);
};

export const shareIntegrationWithWorkspace = (uid: string, permission: string) => {
  const payload = {
    permission
  };

  return api.post(`/integration/${uid}/share_with_workspace`, payload).then((res: any) => res.data);
};
